import { useFeature } from '@features/FeatureToggle';
import { useRouter } from 'next/router';
import { useGetUserPaymentInfo } from '@features/Stripe/hooks/query/use-get-user-payment-info';
import { useAtomValue } from 'jotai';
import { userAtom } from '@features/Stripe';

export const useGetAppName: () => 'Youth' | 'YouthUS' = () => {
  const { userId, email } = useAtomValue(userAtom);
  const isVariantUsEnabled = useFeature('usFeature');
  const { query } = useRouter();
  const userPaymentInfo = useGetUserPaymentInfo({
    email: (query.email as string) || email,
    userId: (query.user_id as string) || userId,
  });

  if (userPaymentInfo?.data?.app) {
    return userPaymentInfo.data.app as 'Youth' | 'YouthUS';
  }

  return isVariantUsEnabled ? 'YouthUS' : 'Youth';
};
